import React from "react";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

interface CustomChipProps {
  label: string;
  color:
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "warning"
    | "info"
    | "neutral";
}

const colorMap = {
  primary: "#a41e35",
  secondary: "#D0A6CD",
  success: "#4caf50",
  error: "#f44336",
  warning: "#FDB913",
  info: "#06A3B0",
  neutral: "#BCA685",
};

const getBackgroundColorWithOpacity = (color: string) => {
  return color + "4D"; // Adding 4D to the hex color to get 30% opacity
};

const StyledChip = styled(Box)<{ bgcolor: string; bordercolor: string }>(
  ({ bgcolor, bordercolor }) => ({
    display: "inline-block",
    padding: "2px 20px",
    borderRadius: "100px",
    backgroundColor: bgcolor,
    border: `1px solid ${bordercolor}`,
    color: "#000",
    fontWeight: 400,
    fontSize: "0.875rem",
    textAlign: "center",
  })
);

const CustomChip: React.FC<CustomChipProps> = ({ label, color }) => {
  const borderColor = colorMap[color];
  const backgroundColor = getBackgroundColorWithOpacity(borderColor);

  return (
    <StyledChip bgcolor={backgroundColor} bordercolor={borderColor}>
      {label}
    </StyledChip>
  );
};

export default CustomChip;
